export default [
    {
        name: 'AreaCandidato',
        path: process.env.VUE_APP_FRONT_URL_RH + '/candidato',
        component: () => import('../views/Visualizar.vue')
    }
]